"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = __importDefault(require("axios"));
const defaultCleanBody = (data) => {
    delete data.id; // eslint-disable-line no-param-reassign
    return data;
};
exports.loopbackCleanBody = defaultCleanBody;
exports.loopbackRequestCreator = (url, cleanBody = defaultCleanBody) => ({
    // Get all records
    getAll: (filter) => axios_1.default.get(url, { params: { filter } }).then((r) => Promise.resolve(r.data)),
    // Count
    count: (filter) => axios_1.default.get(`${url}/count`, filter && filter.where ? { params: { where: filter.where } } : undefined).then((r) => Promise.resolve(r.data)),
    // Get record by id
    getById: (id, filter) => axios_1.default.get(`${url}/${id}`, { params: { filter } }).then((r) => Promise.resolve(r.data)),
    // Delete record by id
    delete: (id) => axios_1.default.delete(`${url}/${id}`).then(() => Promise.resolve({ id })),
    // create record by id
    create: (body) => axios_1.default.post(url, cleanBody(body)).then((r) => Promise.resolve(r.data)),
    // update record by id
    update: (id, body) => axios_1.default.patch(`${url}/${id}`, cleanBody(body)).then((r) => Promise.resolve(r.data)),
});
//# sourceMappingURL=LoopbackRequestCreator.js.map